import React, { useState, useEffect } from 'react';
import { API_URLS } from '../../../config/api';
import { adminApiFetch } from '../../../utils/adminApi';

import { 
  Plus, 
  Edit, 
  Trash2, 
  Eye, 
  EyeOff, 
  Package, 
  Star, 
  Crown,
  CheckCircle,
  XCircle,
  Save,
  X,
  Menu as MenuIcon,
  Settings,
  Search,
  HelpCircle,
  Info,
  AlertCircle,
  AlertTriangle,
  Globe,
  Server,
  Cpu,
  Database,
  Mail,
  Lock,
  Shield,
  ShieldCheck,
  BadgeCheck,
  MonitorSmartphone,
  Palette,
  ShoppingCart,
  Layers,
  Target,
  Rocket,
  Megaphone,
  Users,
  BookOpen,
  GraduationCap,
  Tag,
  RefreshCw,
  Home,
  Phone,
  MapPin,
  Zap,
  Image as ImageIcon,
  Bell,
  Calendar,
  Clock,
  Cloud,
  Copy,
  Download,
  Upload,
  ExternalLink,
  Heart,
  Gift,
  Briefcase,
  Truck,
  CreditCard,
  DollarSign,
  BarChart,
  TrendingUp,
  Award,
  Bookmark,
  Flag,
  Code,
  Terminal,
  Filter,
  Share2,
  Send,
  Paperclip,
  MessageCircle,
  MessageSquare,
  Video,
  Mic,
  Camera,
  Folder,
  File,
  Lightbulb,
  Key,
  Wifi,
  Activity,
  Repeat,
  Bot,
  Layout,
  Grid,
  List,
  ChevronDown,
  ChevronRight,
  Check,
  Minus,
  FileText
} from 'lucide-react';

const AdminAdvertisingPackages = () => {
  // Tab management
  const [activeTab, setActiveTab] = useState('packages'); // 'packages' or 'comparison'
  
  // Package management
  const [packages, setPackages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [globalFeatures, setGlobalFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showFeaturesModal, setShowFeaturesModal] = useState(false);
  const [showGlobalFeaturesModal, setShowGlobalFeaturesModal] = useState(false);
  const [editingPackage, setEditingPackage] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [newFeatureName, setNewFeatureName] = useState('');
  
  // Comparison management
  const [categories, setCategories] = useState([]);
  const [comparisonFeatures, setComparisonFeatures] = useState([]);
  const [featureValues, setFeatureValues] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingFeature, setEditingFeature] = useState(null);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showFeatureModal, setShowFeatureModal] = useState(false);
  const [selectedCategoryForFeature, setSelectedCategoryForFeature] = useState(null);
  const [selectedPackageForValues, setSelectedPackageForValues] = useState(null);
  const [showPackageValuesModal, setShowPackageValuesModal] = useState(false);
  const [packageFeatureValues, setPackageFeatureValues] = useState({});
  const [categoryForm, setCategoryForm] = useState({
    name: '',
    description: '',
    sort_order: 0
  });
  const [featureForm, setFeatureForm] = useState({
    category_id: '',
    name: '',
    description: '',
    sort_order: 0
  });
  
  const [formData, setFormData] = useState({
    name: '',
    subtitle: '',
    original_price: '',
    price: '',
    discount: '',
    color: 'from-gray-500 to-gray-700',
    bg_color: 'bg-gray-50',
    icon: 'Package',
    popular: false,
    description: '',
    features: [],
    included_features: [],
    not_included_features: [],
    sort_order: 0,
    url: ''
  });

  // İkon seçenekleri (AdminMenus.jsx'ten alındı)
  const iconOptions = [
    // Temel İkonlar
    { name: 'Home', component: Home },
    { name: 'Menu', component: MenuIcon },
    { name: 'Settings', component: Settings },
    { name: 'Search', component: Search },
    { name: 'Star', component: Star },
    
    // Bilgi & Yardım
    { name: 'HelpCircle', component: HelpCircle },
    { name: 'Info', component: Info },
    { name: 'AlertCircle', component: AlertCircle },
    { name: 'AlertTriangle', component: AlertTriangle },
    { name: 'CheckCircle', component: CheckCircle },
    { name: 'XCircle', component: XCircle },
    
    // Teknoloji & Hosting
    { name: 'Globe', component: Globe },
    { name: 'Server', component: Server },
    { name: 'Cpu', component: Cpu },
    { name: 'Database', component: Database },
    { name: 'Cloud', component: Cloud },
    { name: 'Wifi', component: Wifi },
    { name: 'Activity', component: Activity },
    { name: 'Terminal', component: Terminal },
    { name: 'Code', component: Code },
    
    // Güvenlik
    { name: 'Lock', component: Lock },
    { name: 'Shield', component: Shield },
    { name: 'ShieldCheck', component: ShieldCheck },
    { name: 'Key', component: Key },
    { name: 'BadgeCheck', component: BadgeCheck },
    
    // İletişim
    { name: 'Mail', component: Mail },
    { name: 'Phone', component: Phone },
    { name: 'MessageCircle', component: MessageCircle },
    { name: 'MessageSquare', component: MessageSquare },
    { name: 'Send', component: Send },
    { name: 'Bell', component: Bell },
    { name: 'Bot', component: Bot },
    
    // E-ticaret & Finans
    { name: 'ShoppingCart', component: ShoppingCart },
    { name: 'Package', component: Package },
    { name: 'Truck', component: Truck },
    { name: 'CreditCard', component: CreditCard },
    { name: 'DollarSign', component: DollarSign },
    { name: 'Gift', component: Gift },
    
    // Tasarım & Medya
    { name: 'MonitorSmartphone', component: MonitorSmartphone },
    { name: 'Palette', component: Palette },
    { name: 'Image', component: ImageIcon },
    { name: 'Camera', component: Camera },
    { name: 'Video', component: Video },
    { name: 'Mic', component: Mic },
    { name: 'Lightbulb', component: Lightbulb },
    
    // İçerik & Belgeler
    { name: 'FileText', component: FileText },
    { name: 'BookOpen', component: BookOpen },
    { name: 'File', component: File },
    { name: 'Folder', component: Folder },
    { name: 'Copy', component: Copy },
    { name: 'Paperclip', component: Paperclip },
    
    // İş & Organizasyon
    { name: 'Briefcase', component: Briefcase },
    { name: 'Users', component: Users },
    { name: 'Calendar', component: Calendar },
    { name: 'Clock', component: Clock },
    { name: 'Tag', component: Tag },
    { name: 'Bookmark', component: Bookmark },
    { name: 'Flag', component: Flag },
    
    // Eğitim & Büyüme
    { name: 'GraduationCap', component: GraduationCap },
    { name: 'Target', component: Target },
    { name: 'Rocket', component: Rocket },
    { name: 'TrendingUp', component: TrendingUp },
    { name: 'BarChart', component: BarChart },
    { name: 'Award', component: Award },
    { name: 'Crown', component: Crown },
    
    // Pazarlama & Sosyal
    { name: 'Megaphone', component: Megaphone },
    { name: 'Share2', component: Share2 },
    { name: 'Heart', component: Heart },
    { name: 'Zap', component: Zap },
    
    // Navigasyon & Aksiyon
    { name: 'ChevronDown', component: ChevronDown },
    { name: 'ChevronRight', component: ChevronRight },
    { name: 'ExternalLink', component: ExternalLink },
    { name: 'Download', component: Download },
    { name: 'Upload', component: Upload },
    { name: 'RefreshCw', component: RefreshCw },
    { name: 'Repeat', component: Repeat },
    
    // Görünüm & Düzen
    { name: 'MapPin', component: MapPin },
    { name: 'Layers', component: Layers },
    { name: 'Layout', component: Layout },
    { name: 'Grid', component: Grid },
    { name: 'List', component: List },
    { name: 'Filter', component: Filter }
  ];

  // Gradient renk seçenekleri (paket kartları için)
  const gradientColorOptions = [
    { value: 'from-gray-500 to-gray-700', label: 'Gri', bg: 'bg-gray-50', preview: '#6b7280' },
    { value: 'from-blue-500 to-blue-700', label: 'Mavi', bg: 'bg-blue-50', preview: '#2563eb' },
    { value: 'from-indigo-500 to-indigo-700', label: 'İndigo', bg: 'bg-indigo-50', preview: '#4f46e5' },
    { value: 'from-purple-500 to-purple-700', label: 'Mor', bg: 'bg-purple-50', preview: '#9333ea' },
    { value: 'from-pink-500 to-pink-700', label: 'Pembe', bg: 'bg-pink-50', preview: '#db2777' },
    { value: 'from-rose-500 to-rose-700', label: 'Kırmızı', bg: 'bg-rose-50', preview: '#e11d48' },
    { value: 'from-orange-500 to-orange-700', label: 'Turuncu', bg: 'bg-orange-50', preview: '#ea580c' },
    { value: 'from-amber-500 to-amber-700', label: 'Amber', bg: 'bg-amber-50', preview: '#d97706' },
    { value: 'from-yellow-500 to-yellow-700', label: 'Sarı', bg: 'bg-yellow-50', preview: '#ca8a04' },
    { value: 'from-green-500 to-green-700', label: 'Yeşil', bg: 'bg-green-50', preview: '#16a34a' },
    { value: 'from-emerald-500 to-emerald-700', label: 'Zümrüt', bg: 'bg-emerald-50', preview: '#059669' },
    { value: 'from-teal-500 to-teal-700', label: 'Deniz Yeşili', bg: 'bg-teal-50', preview: '#0d9488' },
    { value: 'from-cyan-500 to-cyan-700', label: 'Turkuaz', bg: 'bg-cyan-50', preview: '#0891b2' },
    { value: 'from-sky-500 to-sky-700', label: 'Gökyüzü', bg: 'bg-sky-50', preview: '#0284c7' },
    { value: 'from-violet-500 to-violet-700', label: 'Menekşe', bg: 'bg-violet-50', preview: '#7c3aed' },
    { value: 'from-fuchsia-500 to-fuchsia-700', label: 'Füşya', bg: 'bg-fuchsia-50', preview: '#c026d3' },
    { value: 'from-red-500 to-red-700', label: 'Kırmızı (Koyu)', bg: 'bg-red-50', preview: '#dc2626' },
    { value: 'from-lime-500 to-lime-700', label: 'Limon', bg: 'bg-lime-50', preview: '#65a30d' },
    { value: 'from-blue-500 to-purple-700', label: 'Mavi-Mor', bg: 'bg-gradient-to-r from-blue-50 to-purple-50', preview: 'linear-gradient(to right, #2563eb, #7e22ce)' },
    { value: 'from-purple-500 to-pink-700', label: 'Mor-Pembe', bg: 'bg-gradient-to-r from-purple-50 to-pink-50', preview: 'linear-gradient(to right, #9333ea, #be185d)' },
    { value: 'from-pink-500 to-rose-700', label: 'Pembe-Kırmızı', bg: 'bg-gradient-to-r from-pink-50 to-rose-50', preview: 'linear-gradient(to right, #db2777, #be123c)' },
    { value: 'from-orange-500 to-red-700', label: 'Turuncu-Kırmızı', bg: 'bg-gradient-to-r from-orange-50 to-red-50', preview: 'linear-gradient(to right, #ea580c, #b91c1c)' },
    { value: 'from-green-500 to-emerald-700', label: 'Yeşil-Zümrüt', bg: 'bg-gradient-to-r from-green-50 to-emerald-50', preview: 'linear-gradient(to right, #16a34a, #047857)' },
    { value: 'from-cyan-500 to-blue-700', label: 'Turkuaz-Mavi', bg: 'bg-gradient-to-r from-cyan-50 to-blue-50', preview: 'linear-gradient(to right, #0891b2, #1d4ed8)' }
  ];

  useEffect(() => {
    fetchPackages();
    fetchFeatures();
    fetchComparisonData();
  }, []);

  useEffect(() => {
    if (features && Array.isArray(features)) {
      const featureNames = features
        .filter(f => f && f.title && f.is_active == 1)
        .map(f => f.title);
      setGlobalFeatures(featureNames);
    }
  }, [features]);

  const fetchPackages = async () => {
    try {
      // Reklam paketleri için Advertising endpoint kullan
      const response = await adminApiFetch(API_URLS.ADMIN.ADVERTISING_PACKAGES);
      const result = await response.json();
      
      let pkgs = [];
      if (result.status === 'success') {
        pkgs = result.data || [];
      } else if (Array.isArray(result)) {
        pkgs = result;
      }
      
      setPackages(pkgs);
      
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFeatures = async () => {
    try {
      // Reklam paketleri için Advertising features kullan
      const featuresUrl = API_URLS.ADMIN.ADVERTISING_FEATURES;
      const response = await fetch(featuresUrl);
      const result = await response.json();
      if (result.status === 'success') {
        setFeatures(result.data);
      }
    } catch (error) {
      console.error('Error fetching features:', error);
    }
  };

  const fetchComparisonData = async () => {
    try {
      // Reklam paketleri için Advertising categories kullan
      const categoriesUrl = API_URLS.ADMIN.GET_ADVERTISING_FEATURE_CATEGORIES;
      const categoriesResponse = await fetch(categoriesUrl);
      
      if (!categoriesResponse.ok) {
        const errorText = await categoriesResponse.text();
        console.error('Categories response not OK:', categoriesResponse.status, errorText);
        return;
      }
      
      const categoriesText = await categoriesResponse.text();
      
      if (!categoriesText || categoriesText.trim() === '') {
        console.error('Empty response from categories endpoint');
        return;
      }
      
      const categoriesResult = JSON.parse(categoriesText);
      if (categoriesResult.status === 'success') {
        setCategories(categoriesResult.data || []);
        
        // Initialize expanded state for all categories
        const expanded = {};
        (categoriesResult.data || []).forEach(cat => {
          expanded[cat.id] = false;
        });
        setExpandedCategories(expanded);
      } else {
        console.error('Categories fetch failed:', categoriesResult.message);
      }

      // Reklam paketleri için Advertising features kullan
      const featuresUrl = API_URLS.ADMIN.GET_ADVERTISING_COMPARISON_FEATURES;
      const featuresResponse = await fetch(featuresUrl);
      
      if (!featuresResponse.ok) {
        const errorText = await featuresResponse.text();
        console.error('Features response not OK:', featuresResponse.status, errorText);
        return;
      }
      
      const featuresText = await featuresResponse.text();
      
      if (!featuresText || featuresText.trim() === '') {
        console.error('Empty response from features endpoint');
        return;
      }
      
      const featuresResult = JSON.parse(featuresText);
      
      if (featuresResult.status === 'success') {
        const features = featuresResult.data || [];
        setComparisonFeatures(features);
      } else {
        console.error('Features fetch failed:', featuresResult.message);
      }
    } catch (error) {
      console.error('Error fetching comparison data:', error);
    }
  };

  const addGlobalFeature = async (featureName) => {
    if (!featureName.trim()) return;
    
    try {
      // Reklam paketleri için Advertising features kullan
      const createUrl = API_URLS.ADMIN.CREATE_ADVERTISING_FEATURE;
      const response = await fetch(createUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: featureName,
          description: '',
          icon: 'CheckCircle',
          value: null,
          sort_order: features.length
        })
      });

      const result = await response.json();
      if (result.status === 'success') {
        // Features listesini yenile
        fetchFeatures();
        setNewFeatureName('');
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error creating feature:', error);
      alert('Özellik eklenirken hata oluştu');
    }
  };

  const deleteGlobalFeature = async (featureName) => {
    if (!confirm(`"${featureName}" özelliği silinecek. Emin misiniz?`)) return;

    try {
      // Özelliği features listesinden bul
      const feature = features.find(f => f && f.title === featureName);
      if (!feature || !feature.id) {
        alert('Özellik bulunamadı');
        return;
      }

      // Reklam paketleri için Advertising features kullan
      const deleteUrl = `${API_URLS.ADMIN.DELETE_ADVERTISING_FEATURE}&feature_id=${feature.id}`;
      const response = await fetch(deleteUrl);
      const result = await response.json();

      if (result.status === 'success') {
        // Features listesini yenile
        fetchFeatures();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting feature:', error);
      alert('Özellik silinirken hata oluştu');
    }
  };

  const handleSaveCategory = async (e) => {
    e.preventDefault();
    try {
      // Reklam paketleri için Advertising categories kullan
      const url = editingCategory 
        ? API_URLS.ADMIN.UPDATE_ADVERTISING_FEATURE_CATEGORY
        : API_URLS.ADMIN.CREATE_ADVERTISING_FEATURE_CATEGORY;
      
      const payload = editingCategory 
        ? { ...categoryForm, id: editingCategory.id }
        : categoryForm;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      if (result.status === 'success') {
        alert(editingCategory ? 'Kategori güncellendi!' : 'Kategori oluşturuldu!');
        setShowCategoryModal(false);
        setEditingCategory(null);
        setCategoryForm({ name: '', description: '', sort_order: 0 });
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error saving category:', error);
      const errorMessage = error.message || 'Bilinmeyen hata';
      alert('Kategori kaydedilirken hata oluştu: ' + errorMessage);
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (!confirm('Bu kategori ve altındaki tüm özellikler silinecek. Emin misiniz?')) return;
    
    try {
      // Reklam paketleri için Advertising categories kullan
      const url = API_URLS.ADMIN.DELETE_ADVERTISING_FEATURE_CATEGORY(categoryId);
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        alert('Kategori silindi!');
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      const errorMessage = error.message || 'Bilinmeyen hata';
      alert('Kategori silinirken hata oluştu: ' + errorMessage);
    }
  };

  const handleEditCategory = (category) => {
    setEditingCategory(category);
    setCategoryForm({
      name: category.name,
      description: category.description || '',
      sort_order: category.sort_order || 0
    });
    setShowCategoryModal(true);
  };

  const handleSaveFeature = async (e) => {
    e.preventDefault();
    try {
      // Reklam paketleri için Advertising features kullan
      const url = editingFeature 
        ? API_URLS.ADMIN.UPDATE_ADVERTISING_PACKAGE_FEATURE
        : API_URLS.ADMIN.CREATE_ADVERTISING_PACKAGE_FEATURE;
      
      const payload = editingFeature 
        ? { ...featureForm, id: editingFeature.id }
        : featureForm;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        alert(editingFeature ? 'Özellik güncellendi!' : 'Özellik oluşturuldu!');
        setShowFeatureModal(false);
        setEditingFeature(null);
        setSelectedCategoryForFeature(null);
        setFeatureForm({ category_id: '', name: '', description: '', sort_order: 0 });
        fetchComparisonData();
      } else {
        alert('Hata: ' + (result.message || 'Bilinmeyen hata'));
      }
    } catch (error) {
      console.error('Error saving feature:', error);
      const errorMessage = error.message || 'Bilinmeyen hata';
      alert('Özellik kaydedilirken hata oluştu: ' + errorMessage);
    }
  };

  const handleDeleteFeature = async (featureId) => {
    if (!confirm('Bu özellik silinecek. Emin misiniz?')) return;
    
    try {
      // Reklam paketleri için Advertising features kullan
      const url = API_URLS.ADMIN.DELETE_ADVERTISING_PACKAGE_FEATURE(featureId);
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        alert('Özellik silindi!');
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting feature:', error);
      const errorMessage = error.message || 'Bilinmeyen hata';
      alert('Özellik silinirken hata oluştu: ' + errorMessage);
    }
  };

  const handleEditFeature = (feature) => {
    setEditingFeature(feature);
    setFeatureForm({
      category_id: feature.category_id,
      name: feature.name,
      description: feature.description || '',
      sort_order: feature.sort_order || 0
    });
    setShowFeatureModal(true);
  };

  const handleAddFeatureToCategory = (categoryId) => {
    setSelectedCategoryForFeature(categoryId);
    setFeatureForm({
      category_id: categoryId,
      name: '',
      description: '',
      sort_order: 0
    });
    setShowFeatureModal(true);
  };

  const toggleCategoryExpanded = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const handleManagePackageValues = async (pkg) => {
    setSelectedPackageForValues(pkg);
    setShowPackageValuesModal(true);
    
    // Fetch existing values for this package
    try {
      // Reklam paketleri için Advertising values kullan
      const url = `${API_URLS.ADMIN.GET_ADVERTISING_PACKAGE_FEATURE_VALUES}&package_id=${pkg.id}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        const values = {};
        result.data.forEach(v => {
          values[v.feature_id] = {
            value_type: v.value_type,
            value_text: v.value_text
          };
        });
        setPackageFeatureValues(values);
      }
    } catch (error) {
      console.error('Error fetching package feature values:', error);
      setPackageFeatureValues({});
    }
  };

  const handleSavePackageFeatureValues = async () => {
    try {
      const values = Object.keys(packageFeatureValues).map(featureId => ({
        feature_id: parseInt(featureId),
        value_type: packageFeatureValues[featureId].value_type,
        value_text: packageFeatureValues[featureId].value_text
      }));
      
      // Reklam paketleri için Advertising values kullan
      const saveUrl = API_URLS.ADMIN.SAVE_ADVERTISING_PACKAGE_FEATURE_VALUES;
      const response = await fetch(saveUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          package_id: selectedPackageForValues.id,
          values: values
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      if (result.status === 'success') {
        alert('Özellik değerleri kaydedildi!');
        setShowPackageValuesModal(false);
        setSelectedPackageForValues(null);
        setPackageFeatureValues({});
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error saving package feature values:', error);
      const errorMessage = error.message || 'Bilinmeyen hata';
      alert('Özellik değerleri kaydedilirken hata oluştu: ' + errorMessage);
    }
  };

  const handleToggleStatus = async (packageId) => {
    try {
      const response = await adminApiFetch(`${API_URLS.ADMIN.TOGGLE_ADVERTISING_PACKAGE_STATUS}&package_id=${packageId}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const result = await response.json();
      if (result.status === 'success') {
        fetchPackages();
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error toggling status:', error);
      alert('Error toggling status: ' + error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Reklam paketleri için Advertising endpoint kullan
      const url = editingPackage 
        ? API_URLS.ADMIN.UPDATE_ADVERTISING_PACKAGE 
        : API_URLS.ADMIN.CREATE_ADVERTISING_PACKAGE;
      
      const method = 'POST';
      
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          ...formData,
          id: editingPackage?.id
        }),
      });

      const result = await response.json();
      if (result.status === 'success') {
        fetchPackages();
        setShowModal(false);
        resetForm();
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error saving package:', error);
      alert('Error saving package');
    }
  };

  const handleEdit = (pkg) => {
    setEditingPackage(pkg);
    setFormData({
      name: pkg.name || '',
      subtitle: pkg.subtitle || '',
      original_price: pkg.original_price || '',
      price: pkg.price || '',
      discount: pkg.discount || '',
      color: pkg.color || 'from-gray-500 to-gray-700',
      bg_color: pkg.bg_color || 'bg-gray-50',
      icon: pkg.icon || 'Package',
      popular: pkg.popular == 1,
      description: pkg.description || '',
      features: pkg.features ? (typeof pkg.features === 'string' ? JSON.parse(pkg.features) : pkg.features) : [],
      included_features: pkg.included_features ? (typeof pkg.included_features === 'string' ? JSON.parse(pkg.included_features) : pkg.included_features) : [],
      not_included_features: pkg.not_included_features ? (typeof pkg.not_included_features === 'string' ? JSON.parse(pkg.not_included_features) : pkg.not_included_features) : [],
      sort_order: pkg.sort_order || 0,
      url: pkg.url || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (packageId) => {
    if (!confirm('Bu paketi silmek istediğinize emin misiniz?')) return;
    
    try {
      const deleteUrl = `${API_URLS.ADMIN.DELETE_ADVERTISING_PACKAGE}&package_id=${packageId}`;
      const response = await fetch(deleteUrl, {
        method: 'GET',
        credentials: 'include'
      });
      const result = await response.json();
      
      if (result.status === 'success') {
        fetchPackages();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting package:', error);
      alert('Paket silinirken hata oluştu');
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      subtitle: '',
      original_price: '',
      price: '',
      discount: '',
      color: 'from-gray-500 to-gray-700',
      bg_color: 'bg-gray-50',
      icon: 'Package',
      popular: false,
      description: '',
      features: [],
      included_features: [],
      not_included_features: [],
      sort_order: 0,
      url: ''
    });
    setEditingPackage(null);
  };

  const getIconComponent = (iconName) => {
    if (!iconName) return Package;
    // Trim ve normalize et (case-insensitive)
    const normalizedName = String(iconName).trim();
    const iconOption = iconOptions.find(opt => 
      opt.name.toLowerCase() === normalizedName.toLowerCase()
    );
    return iconOption ? iconOption.component : Package;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Reklam Paketleri
        </h1>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab('packages')}
            className={`pb-3 px-4 font-medium border-b-2 transition-colors flex items-center gap-2 ${
              activeTab === 'packages'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Package className="w-4 h-4" />
            Paketler
          </button>
          <button
            onClick={() => setActiveTab('comparison')}
            className={`pb-3 px-4 font-medium border-b-2 transition-colors flex items-center gap-2 ${
              activeTab === 'comparison'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Grid className="w-4 h-4" />
            Paket Karşılaştırma
          </button>
        </div>
      </div>

      {/* Packages Tab */}
      {activeTab === 'packages' && (
        <>
          <div className="flex gap-2 mb-6">
            <button
              onClick={() => setShowGlobalFeaturesModal(true)}
              className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center gap-2"
            >
              <CheckCircle className="w-4 h-4" />
              Global Özellikler ({globalFeatures.length})
            </button>
            <button
              onClick={() => {
                resetForm();
                setShowModal(true);
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <Plus className="w-4 h-4" />
              Yeni Paket
            </button>
          </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {packages.map((pkg) => {
          const IconComponent = getIconComponent(pkg.icon);
          return (
            <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className={`h-2 bg-gradient-to-r ${pkg.color}`}></div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg bg-gradient-to-r ${pkg.color} text-white`}>
                      <IconComponent className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">{pkg.name}</h3>
                      {pkg.popular == 1 && (
                        <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                          Popüler
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleToggleStatus(pkg.id)}
                      className={`p-2 rounded-lg ${pkg.is_active == 1 ? 'text-green-600 hover:bg-green-50' : 'text-gray-400 hover:bg-gray-50'}`}
                    >
                      {pkg.is_active == 1 ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
                    </button>
                    <button
                      onClick={() => handleEdit(pkg)}
                      className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg"
                    >
                      <Edit className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => handleDelete(pkg.id)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-sm text-gray-600 mb-2">{pkg.subtitle}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-gray-900">
                      {pkg.price && pkg.price > 0 ? `₺${pkg.price?.toLocaleString()}` : 'Özel Teklif'}
                    </span>
                    {pkg.original_price > pkg.price && (
                      <span className="text-sm text-gray-500 line-through">₺{pkg.original_price?.toLocaleString()}</span>
                    )}
                    {pkg.discount > 0 && (
                      <span className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">
                        %{pkg.discount} İndirim
                      </span>
                    )}
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-sm text-gray-600">{pkg.description}</p>
                  {pkg.url && (
                    <div className="mt-2 flex items-center gap-2">
                      <span className="text-xs text-gray-500">URL:</span>
                      <a 
                        href={pkg.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-xs text-blue-600 hover:underline truncate"
                      >
                        {pkg.url}
                      </a>
                    </div>
                  )}
                </div>

                {/* Features */}
                {pkg.features && (() => {
                  try {
                    const featuresData = typeof pkg.features === 'string' ? JSON.parse(pkg.features) : pkg.features;
                    const featuresList = Array.isArray(featuresData) ? featuresData.filter(f => f && f.included).map(f => f.name || f) : [];
                    
                    if (featuresList.length === 0) return null;
                    
                    return (
                      <div className="mb-4">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">Özellikler:</h4>
                        <ul className="space-y-1">
                          {featuresList.slice(0, 5).map((feature, idx) => (
                            <li key={idx} className="text-xs text-gray-600 flex items-center gap-1">
                              <CheckCircle className="w-3 h-3 text-green-500" />
                              {feature}
                            </li>
                          ))}
                          {featuresList.length > 5 && (
                            <li className="text-xs text-gray-500">+{featuresList.length - 5} daha...</li>
                          )}
                        </ul>
                      </div>
                    );
                  } catch (e) {
                    return null;
                  }
                })()}
              </div>
            </div>
          );
        })}
      </div>
        </>
      )}

      {/* Comparison Tab */}
      {activeTab === 'comparison' && (
        <div className="space-y-4 sm:space-y-6">
          {/* Packages List for Value Management */}
          <div className="bg-white rounded-lg shadow p-4 sm:p-6">
            <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3 sm:mb-4">Paketler</h2>
            {packages.length === 0 ? (
              <p className="text-sm sm:text-base text-gray-500 text-center py-6 sm:py-8 break-words px-2">Henüz paket yok</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                {packages.map((pkg) => {
                  return (
                    <div key={pkg.id} className="border border-gray-200 rounded-lg p-3 sm:p-4 hover:shadow-md transition-shadow">
                      <div className="flex items-center gap-2 sm:gap-3 mb-3">
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-sm sm:text-base text-gray-900 break-words">{pkg.name}</h3>
                          {pkg.subtitle && (
                            <p className="text-xs text-gray-500 break-words mt-1">{pkg.subtitle}</p>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={() => handleManagePackageValues(pkg)}
                        className="w-full bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 text-xs sm:text-sm"
                      >
                        <Grid className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                        <span className="break-words">Özellik Değerleri</span>
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Kategori ve Özellik Yönetimi */}
          <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 sm:gap-4">
            <h2 className="text-base sm:text-lg font-bold text-gray-900">Kategoriler ve Özellikler</h2>
            <button
              onClick={() => {
                setEditingCategory(null);
                setCategoryForm({ name: '', description: '', sort_order: 0 });
                setShowCategoryModal(true);
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              <Plus className="w-4 h-4 flex-shrink-0" />
              <span>Yeni Kategori</span>
            </button>
          </div>

          {/* Categories List */}
          {categories.length === 0 ? (
            <div className="text-center py-8 sm:py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 px-4">
              <List className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 sm:mb-4 text-gray-400" />
              <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2 break-words">Henüz kategori yok</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 break-words px-2">
                Paket karşılaştırma tablosu için kategoriler ve özellikler ekleyin
              </p>
              <button
                onClick={() => setShowCategoryModal(true)}
                className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 w-full sm:w-auto justify-center"
              >
                <Plus className="w-4 h-4 flex-shrink-0" />
                <span>İlk Kategoriyi Ekle</span>
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {categories.map((category) => {
                const categoryFeatures = comparisonFeatures.filter(
                  f => f.category_id === category.id
                );
                const isExpanded = expandedCategories[category.id];

                return (
                  <div key={category.id} className="bg-white rounded-lg shadow border border-gray-200">
                    <div className="p-3 sm:p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-2 bg-gray-50 rounded-t-lg">
                      <div className="flex items-center gap-2 sm:gap-3 flex-1 w-full sm:w-auto min-w-0">
                        <button
                          onClick={() => toggleCategoryExpanded(category.id)}
                          className="p-1 hover:bg-gray-200 rounded flex-shrink-0"
                        >
                          {isExpanded ? (
                            <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
                          ) : (
                            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
                          )}
                        </button>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-base sm:text-lg text-gray-900 break-words">{category.name}</h3>
                          {category.description && (
                            <p className="text-xs sm:text-sm text-gray-600 break-words mt-1">{category.description}</p>
                          )}
                        </div>
                        <span className="ml-auto sm:ml-0 text-xs sm:text-sm text-gray-500 bg-white px-2 sm:px-3 py-1 rounded-full flex-shrink-0">
                          {categoryFeatures.length} özellik
                        </span>
                      </div>
                      <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
                        <button
                          onClick={() => handleAddFeatureToCategory(category.id)}
                          className="p-2 text-green-600 hover:bg-green-50 rounded-lg flex-shrink-0"
                          title="Özellik Ekle"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleEditCategory(category)}
                          className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg flex-shrink-0"
                          title="Düzenle"
                        >
                          <Edit className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleDeleteCategory(category.id)}
                          className="p-2 text-red-600 hover:bg-red-50 rounded-lg flex-shrink-0"
                          title="Sil"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>

                    {/* Features List */}
                    {isExpanded && (
                      <div className="p-3 sm:p-4 space-y-2">
                        {categoryFeatures.length === 0 ? (
                          <div className="text-center py-6 sm:py-8 text-gray-500">
                            <FileText className="w-6 h-6 sm:w-8 sm:h-8 mx-auto mb-2 opacity-50" />
                            <p className="text-xs sm:text-sm break-words px-2">Bu kategoride henüz özellik yok</p>
                            <button
                              onClick={() => handleAddFeatureToCategory(category.id)}
                              className="mt-2 text-blue-600 hover:underline text-xs sm:text-sm"
                            >
                              + Özellik Ekle
                            </button>
                          </div>
                        ) : (
                          categoryFeatures.map((feature) => (
                            <div
                              key={feature.id}
                              className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-0 p-3 bg-gray-50 rounded-lg hover:bg-gray-100"
                            >
                              <div className="flex-1 min-w-0 w-full sm:w-auto">
                                <h4 className="font-medium text-sm sm:text-base text-gray-900 break-words">{feature.name}</h4>
                                {feature.description && (
                                  <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">{feature.description}</p>
                                )}
                              </div>
                              <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
                                <button
                                  onClick={() => handleEditFeature(feature)}
                                  className="p-1 text-blue-600 hover:text-blue-700 flex-shrink-0"
                                  title="Düzenle"
                                >
                                  <Edit className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={() => handleDeleteFeature(feature.id)}
                                  className="p-1 text-red-600 hover:text-red-700 flex-shrink-0"
                                  title="Sil"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Package Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingPackage ? 'Paketi Düzenle' : 'Yeni Paket'}
              </h2>
              <button
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Paket Adı</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Alt Başlık</label>
                  <input
                    type="text"
                    value={formData.subtitle}
                    onChange={(e) => setFormData({...formData, subtitle: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Orijinal Fiyat</label>
                  <input
                    type="number"
                    value={formData.original_price}
                    onChange={(e) => setFormData({...formData, original_price: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Boş bırakılabilir"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fiyat <span className="text-gray-400 text-xs">(Boş bırakılırsa "Özel Teklif" gösterilir)</span></label>
                  <input
                    type="number"
                    value={formData.price}
                    onChange={(e) => setFormData({...formData, price: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Boş bırakılabilir"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">İndirim (%)</label>
                  <input
                    type="number"
                    value={formData.discount}
                    onChange={(e) => setFormData({...formData, discount: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              {/* İkon Seçimi */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">İkon Seçimi</label>
                {/* Seçili İkon */}
                {formData.icon && (
                  <div className="mt-2 mb-3 flex items-center gap-2 p-3 bg-purple-50 border border-purple-200 rounded-lg">
                    {(() => {
                      const IconComponent = getIconComponent(formData.icon);
                      return <IconComponent className="w-6 h-6 text-purple-600" />;
                    })()}
                    <span className="font-medium text-purple-900">{formData.icon}</span>
                    <button
                      type="button"
                      onClick={() => setFormData({ ...formData, icon: 'Package' })}
                      className="ml-auto text-xs text-gray-500 hover:text-gray-700"
                    >
                      Temizle
                    </button>
                  </div>
                )}
                {/* İkon Grid */}
                <div className="grid grid-cols-8 gap-2 mt-2 max-h-64 overflow-y-auto p-2 border border-gray-200 rounded-lg bg-gray-50">
                  {iconOptions.map((icon) => {
                    const IconComponent = icon.component;
                    const isSelected = formData.icon === icon.name;
                    return (
                      <button
                        key={icon.name}
                        type="button"
                        onClick={() => setFormData({ ...formData, icon: icon.name })}
                        className={`flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all hover:shadow-md ${
                          isSelected
                            ? 'border-purple-600 bg-purple-50 scale-105'
                            : 'border-gray-300 bg-white hover:border-purple-400'
                        }`}
                        title={icon.name}
                      >
                        <IconComponent className={`w-6 h-6 ${isSelected ? 'text-purple-600' : 'text-gray-600'}`} />
                        <span className="text-[9px] mt-1 text-gray-500 text-center leading-tight">{icon.name}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Renk Seçimi */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Renk Seçimi (Gradient)</label>
                {/* Seçili Renk */}
                {formData.color && (
                  <div className="mt-2 mb-3 flex items-center gap-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                    {(() => {
                      const selectedColor = gradientColorOptions.find(c => c.value === formData.color);
                      const hasGradient = selectedColor?.preview?.includes('linear-gradient');
                      return (
                        <div 
                          className={`w-8 h-8 rounded-lg ${!hasGradient ? `bg-gradient-to-r ${formData.color}` : ''}`}
                          style={hasGradient ? { background: selectedColor.preview } : {}}
                        ></div>
                      );
                    })()}
                    <span className="font-medium text-gray-900">
                      {gradientColorOptions.find(c => c.value === formData.color)?.label || formData.color}
                    </span>
                  </div>
                )}
                {/* Renk Grid */}
                <div className="grid grid-cols-5 gap-2 mt-2 max-h-64 overflow-y-auto p-2 border border-gray-200 rounded-lg bg-gray-50">
                  {gradientColorOptions.map((color) => {
                    const isSelected = formData.color === color.value;
                    const hasGradient = typeof color.preview === 'string' && color.preview.includes('linear-gradient');
                    return (
                      <button
                        key={color.value}
                        type="button"
                        onClick={() => setFormData({
                          ...formData,
                          color: color.value,
                          bg_color: color.bg
                        })}
                        className={`h-20 rounded-lg border-2 transition-all flex flex-col items-center justify-center overflow-hidden ${
                          isSelected
                            ? 'border-purple-600 scale-105 shadow-md ring-2 ring-purple-300'
                            : 'border-gray-300 hover:border-purple-400'
                        }`}
                        title={color.label}
                      >
                        <div 
                          className={`w-full h-12 rounded-t-lg ${hasGradient ? '' : `bg-gradient-to-r ${color.value}`}`}
                          style={hasGradient ? { background: color.preview } : {}}
                        ></div>
                        <span className={`text-[10px] px-1 mt-1 font-medium text-center leading-tight ${isSelected ? 'text-purple-700' : 'text-gray-600'}`}>
                          {color.label}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Açıklama</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Sıralama</label>
                  <input
                    type="number"
                    value={formData.sort_order}
                    onChange={(e) => setFormData({...formData, sort_order: parseInt(e.target.value) || 0})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={formData.popular}
                      onChange={(e) => setFormData({...formData, popular: e.target.checked})}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <span className="text-sm font-medium text-gray-700">Popüler Paket</span>
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Satın Alma URL</label>
                <input
                  type="text"
                  value={formData.url}
                  onChange={(e) => setFormData({...formData, url: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="/reklam-hizmetleri veya https://..."
                />
              </div>

              <div className="flex justify-end gap-2 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  {editingPackage ? 'Güncelle' : 'Oluştur'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Global Features Modal */}
      {showGlobalFeaturesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Global Özellikler Yönetimi</h2>
              <button
                onClick={() => setShowGlobalFeaturesModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm text-blue-800">
                <strong>Önemli:</strong> Buradan eklediğiniz özellikler Reklam özellikler listesine eklenir.
                Sildiğiniz özellikler Reklam özellikler listesinden silinir.
              </p>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Yeni Özellik Ekle
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={newFeatureName}
                  onChange={(e) => setNewFeatureName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      addGlobalFeature(newFeatureName);
                    }
                  }}
                  placeholder="Özellik adı..."
                  className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  onClick={() => addGlobalFeature(newFeatureName)}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Plus className="w-4 h-4" />
                  Ekle
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mevcut Özellikler ({globalFeatures.length})
              </label>
              {globalFeatures.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <Package className="w-12 h-12 mx-auto mb-2 opacity-50" />
                  <p>Henüz özellik eklenmemiş</p>
                </div>
              ) : (
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {globalFeatures.map((feature, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between bg-gray-50 p-3 rounded-lg hover:bg-gray-100"
                    >
                      <span className="text-gray-900 font-medium">{feature}</span>
                      <button
                        onClick={() => deleteGlobalFeature(feature)}
                        className="text-red-600 hover:text-red-700 p-1"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowGlobalFeaturesModal(false)}
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Category Modal */}
      {showCategoryModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingCategory ? 'Kategoriyi Düzenle' : 'Yeni Kategori'}
              </h2>
              <button
                onClick={() => {
                  setShowCategoryModal(false);
                  setEditingCategory(null);
                  setCategoryForm({ name: '', description: '', sort_order: 0 });
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSaveCategory} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Kategori Adı
                </label>
                <input
                  type="text"
                  value={categoryForm.name}
                  onChange={(e) => setCategoryForm({...categoryForm, name: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Genel Özellikler"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Açıklama
                </label>
                <textarea
                  value={categoryForm.description}
                  onChange={(e) => setCategoryForm({...categoryForm, description: e.target.value})}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Kategori açıklaması..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sıralama
                </label>
                <input
                  type="number"
                  value={categoryForm.sort_order}
                  onChange={(e) => setCategoryForm({...categoryForm, sort_order: parseInt(e.target.value) || 0})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="0"
                />
                <p className="text-xs text-gray-500 mt-1">Küçük sayılar önce gösterilir</p>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowCategoryModal(false);
                    setEditingCategory(null);
                    setCategoryForm({ name: '', description: '', sort_order: 0 });
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Feature Modal */}
      {showFeatureModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingFeature ? 'Özelliği Düzenle' : 'Yeni Özellik'}
              </h2>
              <button
                onClick={() => {
                  setShowFeatureModal(false);
                  setEditingFeature(null);
                  setSelectedCategoryForFeature(null);
                  setFeatureForm({ category_id: '', name: '', description: '', sort_order: 0 });
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSaveFeature} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Kategori
                </label>
                <select
                  value={featureForm.category_id}
                  onChange={(e) => setFeatureForm({...featureForm, category_id: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                  disabled={!!selectedCategoryForFeature}
                >
                  <option value="">Kategori seçin...</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Özellik Adı
                </label>
                <input
                  type="text"
                  value={featureForm.name}
                  onChange={(e) => setFeatureForm({...featureForm, name: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="7/24 Destek & Eğitim"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Açıklama
                </label>
                <textarea
                  value={featureForm.description}
                  onChange={(e) => setFeatureForm({...featureForm, description: e.target.value})}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Özellik açıklaması..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sıralama
                </label>
                <input
                  type="number"
                  value={featureForm.sort_order}
                  onChange={(e) => setFeatureForm({...featureForm, sort_order: parseInt(e.target.value) || 0})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="0"
                />
                <p className="text-xs text-gray-500 mt-1">Küçük sayılar önce gösterilir</p>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowFeatureModal(false);
                    setEditingFeature(null);
                    setSelectedCategoryForFeature(null);
                    setFeatureForm({ category_id: '', name: '', description: '', sort_order: 0 });
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Package Feature Values Modal */}
      {showPackageValuesModal && selectedPackageForValues && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="bg-white rounded-lg w-full max-w-[95vw] sm:max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-0 p-4 sm:p-6 border-b border-gray-200">
              <div className="flex-1 min-w-0">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 break-words">
                  {selectedPackageForValues.name} - Özellik Değerleri
                </h2>
                <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">
                  Her özellik için bir değer tipi seçin
                </p>
              </div>
              <button
                onClick={() => {
                  setShowPackageValuesModal(false);
                  setSelectedPackageForValues(null);
                  setPackageFeatureValues({});
                }}
                className="text-gray-500 hover:text-gray-700 flex-shrink-0 self-end sm:self-auto"
              >
                <X className="w-5 h-5 sm:w-6 sm:h-6" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-3 sm:p-6">
              {comparisonFeatures.length === 0 ? (
                <div className="text-center py-8 sm:py-12">
                  <FileText className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 sm:mb-4 text-gray-400" />
                  <p className="text-sm sm:text-base text-gray-600 mb-2 break-words">Henüz özellik yok</p>
                  <p className="text-xs sm:text-sm text-gray-500 break-words px-2">
                    Önce kategoriler ve özellikler oluşturun
                  </p>
                </div>
              ) : (
                <div className="space-y-4 sm:space-y-6">
                  {categories.map((category) => {
                    const categoryFeatures = comparisonFeatures.filter(
                      f => f.category_id === category.id
                    );
                    
                    if (categoryFeatures.length === 0) return null;

                    return (
                      <div key={category.id} className="border border-gray-200 rounded-lg overflow-hidden">
                        <div className="bg-gray-100 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-200">
                          <h3 className="font-bold text-sm sm:text-base text-gray-900 break-words">{category.name}</h3>
                          {category.description && (
                            <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">{category.description}</p>
                          )}
                        </div>
                        <div className="divide-y divide-gray-200">
                          {categoryFeatures.map((feature) => {
                            const currentValue = packageFeatureValues[feature.id] || { value_type: 'cross', value_text: null };
                            
                            return (
                              <div key={feature.id} className="p-3 sm:p-4 hover:bg-gray-50">
                                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                                  <div className="flex-1 min-w-0 w-full sm:w-auto">
                                    <h4 className="font-medium text-sm sm:text-base text-gray-900 break-words">{feature.name}</h4>
                                    {feature.description && (
                                      <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">{feature.description}</p>
                                    )}
                                  </div>
                                  <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
                                    <button
                                      onClick={() => {
                                        setPackageFeatureValues({
                                          ...packageFeatureValues,
                                          [feature.id]: { value_type: 'check', value_text: null }
                                        });
                                      }}
                                      className={`p-2 rounded-lg transition-colors flex-shrink-0 ${
                                        currentValue.value_type === 'check'
                                          ? 'bg-green-100 text-green-600 ring-2 ring-green-500'
                                          : 'bg-gray-100 text-gray-400 hover:bg-green-50'
                                      }`}
                                      title="Var"
                                    >
                                      <Check className="w-4 h-4 sm:w-5 sm:h-5" />
                                    </button>
                                    <button
                                      onClick={() => {
                                        setPackageFeatureValues({
                                          ...packageFeatureValues,
                                          [feature.id]: { value_type: 'cross', value_text: null }
                                        });
                                      }}
                                      className={`p-2 rounded-lg transition-colors flex-shrink-0 ${
                                        currentValue.value_type === 'cross'
                                          ? 'bg-red-100 text-red-600 ring-2 ring-red-500'
                                          : 'bg-gray-100 text-gray-400 hover:bg-red-50'
                                      }`}
                                      title="Yok"
                                    >
                                      <X className="w-4 h-4 sm:w-5 sm:h-5" />
                                    </button>
                                    <button
                                      onClick={() => {
                                        setPackageFeatureValues({
                                          ...packageFeatureValues,
                                          [feature.id]: { value_type: 'optional', value_text: null }
                                        });
                                      }}
                                      className={`p-2 rounded-lg transition-colors flex-shrink-0 ${
                                        currentValue.value_type === 'optional'
                                          ? 'bg-orange-100 text-orange-600 ring-2 ring-orange-500'
                                          : 'bg-gray-100 text-gray-400 hover:bg-orange-50'
                                      }`}
                                      title="İsteğe Bağlı"
                                    >
                                      <Minus className="w-4 h-4 sm:w-5 sm:h-5" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4 p-4 sm:p-6 border-t border-gray-200 bg-gray-50">
              <div className="flex flex-wrap items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-600 justify-center sm:justify-start">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-green-100 text-green-600 rounded flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                  <span>Var</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-red-100 text-red-600 rounded flex items-center justify-center flex-shrink-0">
                    <X className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                  <span>Yok</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-orange-100 text-orange-600 rounded flex items-center justify-center flex-shrink-0">
                    <Minus className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                  <span>İsteğe Bağlı</span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
                <button
                  onClick={() => {
                    setShowPackageValuesModal(false);
                    setSelectedPackageForValues(null);
                    setPackageFeatureValues({});
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 w-full sm:w-auto"
                >
                  İptal
                </button>
                <button
                  onClick={handleSavePackageFeatureValues}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 w-full sm:w-auto"
                >
                  <Save className="w-4 h-4 flex-shrink-0" />
                  Kaydet
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAdvertisingPackages;
